import React, { useEffect, useState } from "react";

import './MainPage.css';
import { decodeJwt } from "../../utils";
import SearchableList from '../../components/searchable_list.js'

const page_list = [
  { 'title': '/rgb', 'link': '/rgb' },
  { 'title': '/rasoi', 'link': '/rasoi' },
  { 'title': '/birdbot', 'link': 'https://birdbot.co.uk' },
  { 'title': '/run_your_city', 'link': '/run_your_city' },
  { 'title': '/idioms', 'link': '/idioms' },
  { 'title': '/ads', 'link': '/ads' },
  // { 'title': '/sourdough', 'link': '/sourdough' },  // FIXME: re-implement this.
  { 'title': '/login', 'link': '/login' },
  { 'title': '/gromit_map', 'link': '/gromit_unleashed' },
  { 'title': '/planmyplate', 'link': 'https://planmyplate.co.uk' },
  { 'title': '/bbox_viewer', 'link': '/bboxes' },
];

const MainPage = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    let token = localStorage.getItem("euans_website")
    if (token !== null) {
      setLoggedIn(decodeJwt(token));
    }
  }, []);


  return (
    <div className="MainPage" style={{ backgroundColor: loggedIn ? "rgba(255,0,255)" : "" }}>
      {loggedIn && <h2 className="welcome_message">Hello Euan</h2>}
      <header className="main_page_header">
        <h1 className="MainTitle">euan's website</h1>
      </header>
      <div className="main_body">
        <SearchableList data={page_list} />
      </div>
    </div>
  );
}


export default MainPage;
